module.exports = __webpack_public_path__ + "img/logo-tanaleiPublico.dffea16f.svg";